import React from 'react';
import { XCircleIcon, AlertTriangleIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    text: 'כתמי עובש על הקירות',
    icon: XCircleIcon
  }, {
    text: 'ריח לחות מעיק בבית',
    icon: XCircleIcon
  }, {
    text: 'קילוף של צבע וטיח',
    icon: XCircleIcon
  }, {
    text: 'נזק לרצפת הפרקט',
    icon: XCircleIcon
  }, {
    text: 'בעיות בריאות לבני המשפחה',
    icon: XCircleIcon
  }, {
    text: 'ירידת ערך הנכס',
    icon: XCircleIcon
  }];
  return <section className="py-20 bg-white px-4 md:px-8" data-id="element-118">
      <div className="max-w-6xl mx-auto" data-id="element-119">
        <div className="text-center mb-16" data-id="element-120">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-121">
            האם אתם סובלים מ...
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-122">
            רטיבות היא לא רק בעיה אסתטית – היא סכנה בריאותית והורסת את הנכס שלכם
            מבפנים.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-123">
          {problems.map((item, index) => <div key={index} className="flex items-center gap-4 p-6 bg-red-50 rounded-xl border border-red-100 hover:shadow-md transition-shadow" data-id="element-124">
              <item.icon className="w-8 h-8 text-red-500 flex-shrink-0" data-id="element-125" />
              <span className="text-lg font-bold text-gray-800" data-id="element-126">
                {item.text}
              </span>
            </div>)}
        </div>

        <div className="bg-orange-50 border-2 border-orange-200 rounded-2xl p-8 text-center max-w-4xl mx-auto relative overflow-hidden" data-id="element-127">
          <div className="absolute top-0 right-0 w-20 h-20 bg-orange-200 rounded-bl-full opacity-50" data-id="element-128"></div>
          <div className="absolute bottom-0 left-0 w-20 h-20 bg-orange-200 rounded-tr-full opacity-50" data-id="element-129"></div>

          <div className="relative z-10 flex flex-col md:flex-row items-center justify-center gap-6" data-id="element-130">
            <AlertTriangleIcon className="w-12 h-12 text-[#f97316] animate-bounce" data-id="element-131" />
            <div className="text-right md:text-center" data-id="element-132">
              <h3 className="text-2xl font-black text-gray-900 mb-2" data-id="element-133">
                אל תחכו! כל יום של עיכוב = נזק גדול יותר ויקר יותר
              </h3>
              <p className="text-xl font-bold text-[#f97316]" data-id="element-134">
                התקשרו עכשיו לייעוץ חירום:{' '}
                <a href="tel:0523552222" className="underline" data-id="element-135">
                  052-355-2222
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}